export default __webpack_public_path__ + "static/media/loading.391e30e2.png";